
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ExternalLink, Linkedin, Instagram, Youtube } from 'lucide-react';

const SocialMediaContent = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Social Media Präsenzen</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6 text-joerg-600">
        <p className="text-sm leading-relaxed">
          Diese Website enthält Links zu meinen Profilen auf verschiedenen sozialen Netzwerken. Wenn Sie diese Links nutzen, werden Sie zu meinen Profilen auf den jeweiligen Plattformen weitergeleitet. Dabei werden Daten an die Betreiber der jeweiligen Plattformen übermittelt. Die Datenübermittlung erfolgt unabhängig davon, ob Sie ein Konto bei dem jeweiligen Anbieter besitzen und dort eingeloggt sind.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <a 
            href="https://linkedin.com/in/joerg-hoermann" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-3 p-4 rounded-lg border border-gray-200 hover:border-primary transition-colors hover:bg-joerg-50 group"
          >
            <div className="bg-[#0A66C2] text-white rounded-full p-2.5">
              <Linkedin className="h-5 w-5" />
            </div>
            <div>
              <h5 className="font-medium text-joerg-800 group-hover:text-primary transition-colors">LinkedIn</h5>
              <p className="text-sm text-joerg-600 flex items-center gap-1">
                <span>linkedin.com/in/joerg-hoermann</span>
                <ExternalLink className="h-3 w-3" />
              </p>
            </div>
          </a>
          
          <a 
            href="https://www.instagram.com/joerg_hoermann/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-3 p-4 rounded-lg border border-gray-200 hover:border-primary transition-colors hover:bg-joerg-50 group"
          >
            <div className="bg-gradient-to-br from-[#405DE6] via-[#E1306C] to-[#FFDC80] text-white rounded-full p-2.5">
              <Instagram className="h-5 w-5" />
            </div>
            <div>
              <h5 className="font-medium text-joerg-800 group-hover:text-primary transition-colors">Instagram</h5>
              <p className="text-sm text-joerg-600 flex items-center gap-1">
                <span>instagram.com/joerg_hoermann</span>
                <ExternalLink className="h-3 w-3" />
              </p>
            </div>
          </a>
          
          <a 
            href="https://www.youtube.com/@Hoermann_Coaching_Consulting" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-3 p-4 rounded-lg border border-gray-200 hover:border-primary transition-colors hover:bg-joerg-50 group"
          >
            <div className="bg-[#FF0000] text-white rounded-full p-2.5">
              <Youtube className="h-5 w-5" />
            </div>
            <div>
              <h5 className="font-medium text-joerg-800 group-hover:text-primary transition-colors">YouTube</h5>
              <p className="text-sm text-joerg-600 flex items-center gap-1">
                <span>youtube.com/@Hoermann_Coaching_Consulting</span>
                <ExternalLink className="h-3 w-3" />
              </p>
            </div>
          </a>
          
          <a 
            href="https://bsky.app/profile/joerg-hoermann.bsky.social" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-3 p-4 rounded-lg border border-gray-200 hover:border-primary transition-colors hover:bg-joerg-50 group"
          >
            <div className="bg-[#0085FF] text-white rounded-full p-2.5">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
                <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm3.75,14-1-2.5h-5.5l-1,2.5h-2.5l5-12,5,12Z"/>
              </svg>
            </div>
            <div>
              <h5 className="font-medium text-joerg-800 group-hover:text-primary transition-colors">BlueSky</h5>
              <p className="text-sm text-joerg-600 flex items-center gap-1">
                <span>joerg-hoermann.bsky.social</span>
                <ExternalLink className="h-3 w-3" />
              </p>
            </div>
          </a>
        </div>
        
        <div className="text-sm space-y-3 mt-4">
          <p className="font-medium text-joerg-700">Hinweis zur Datenverarbeitung auf sozialen Netzwerken:</p>
          <p className="leading-relaxed">
            Bitte beachten Sie, dass die Betreiber der sozialen Netzwerke Ihre Nutzerdaten erheben und verarbeiten, wenn Sie auf meine Profile zugreifen. Die Datenverarbeitung erfolgt auf Basis der Datenschutzrichtlinien der jeweiligen Anbieter. Ich habe keinen Einfluss auf die Art und den Umfang der Datenverarbeitung durch die Betreiber der sozialen Netzwerke. Weitere Informationen zur Datenverarbeitung und Ihren Rechten finden Sie in den Datenschutzerklärungen der jeweiligen Anbieter:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>LinkedIn: <a href="https://www.linkedin.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">https://www.linkedin.com/legal/privacy-policy</a></li>
            <li>Instagram: <a href="https://help.instagram.com/519522125107875" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">https://help.instagram.com/519522125107875</a></li>
            <li>YouTube: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">https://policies.google.com/privacy</a></li>
            <li>BlueSky: <a href="https://bsky.social/about/policies/privacy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">https://bsky.social/about/policies/privacy</a></li>
          </ul>
        </div>
      </CardContent>
    </Card>
  );
};

export default SocialMediaContent;
